export const flex = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 2,
};

export const flexCol = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: 3,
};

export const styleModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: 350, sm: 600, md: 800 },
    minHeight: 200,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    bgcolor: "background.paper",
    border: "2px solid #000",
    borderRadius: "35px",
    boxShadow: 24,
    p: 4,
    gap: 3,
};
